/**
 * Articole blog e-Tesa
 * Adaugă/editează articole aici. Fiecare articol = un obiect în array.
 * Conținutul suportă HTML (sanitizat la afișare) — folosește <h2>, <p>, <ul>, <li>, <strong>, <a>.
 */

export const blogArticles = [
  {
    slug: "pontaj-digital-santier-ghid-2026",
    title: "Cum să eficientizezi pontajul angajaților de pe șantier în 2026",
    excerpt:
      "Pontajul pe hârtie costă o firmă medie de construcții ~40 ore/lună de muncă administrativă. Iată cum digitalizezi tot procesul fără friction pentru muncitori.",
    date: "2026-05-10",
    readingTime: "6 min",
    category: "Pontaj",
    image: "/etesa-logo.png",
    keywords: "pontaj santier, pontaj digital, gestiune angajati constructii, pontaj online Romania",
    content: `
<h2>De ce pontajul pe hârtie nu mai e o opțiune</h2>
<p>Într-o firmă medie de construcții cu 15–30 de angajați, pontajul manual înseamnă:</p>
<ul>
  <li>Foi de prezență colectate săptămânal de pe fiecare șantier</li>
  <li>Centralizare manuală în Excel — minim 8 ore/lună</li>
  <li>Erori de transcriere care duc la conflicte cu angajații sau cu contabilitatea</li>
  <li>Imposibilitatea de a verifica în timp real cine e pe ce șantier</li>
</ul>

<h2>Ce trebuie să caute o firmă într-o soluție de pontaj digital</h2>
<p>Nu orice aplicație de pontaj e potrivită pentru construcții. Particularitățile industriei impun cerințe specifice:</p>
<ul>
  <li><strong>Validare GPS</strong> — confirmă că angajatul e fizic pe șantier când se pontează</li>
  <li><strong>Funcționare offline</strong> — multe șantiere n-au semnal stabil</li>
  <li><strong>Cereri de concediu</strong> integrate (CO, CM, CS) cu aprobare digitală</li>
  <li><strong>Sărbători legale calculate automat</strong> — inclusiv Paștele Ortodox și Rusaliile</li>
  <li><strong>Export PDF/Excel</strong> pentru contabilitate, fără reintroducere manuală</li>
</ul>

<h2>Flow recomandat pentru o tranziție lină</h2>
<p>Trecerea de la hârtie la digital eșuează când e impusă brusc. Iată planul în 3 pași:</p>
<p><strong>Săptămâna 1–2:</strong> Doar administratorul folosește platforma — introduce manual pontajul colectat de pe șantier, în paralel cu hârtia.</p>
<p><strong>Săptămâna 3–4:</strong> 2–3 angajați "campioni" încep să se ponteze singuri din aplicația mobilă (PWA). Restul rămân pe hârtie.</p>
<p><strong>Săptămâna 5+:</strong> Toți angajații folosesc aplicația. Hârtia devine backup pentru cazurile excepționale.</p>

<h2>Cât economisești efectiv?</h2>
<p>Datele clienților e-Tesa arată o economie medie de <strong>32 ore/lună</strong> de muncă administrativă pentru o firmă cu 20 de angajați. La un cost mediu de 25 RON/oră, asta înseamnă ~800 RON economisiți lunar — fără să punem la socoteală reducerea conflictelor și acuratețea mai bună pentru salarii.</p>
    `.trim(),
  },
  {
    slug: "devize-constructii-ai-2026",
    title: "Devize de construcții generate cu AI: ghid complet pentru 2026",
    excerpt:
      "Trecerea de la devize făcute manual în Excel la generare automată cu AI reduce timpul de la 4 ore la 15 minute pentru o ofertă standard. Cum funcționează și ce să iei în calcul.",
    date: "2026-04-22",
    readingTime: "8 min",
    category: "Devize",
    image: "/etesa-logo.png",
    keywords: "deviz constructii, deviz online, deviz AI, DevizPRO, oferta constructii Romania",
    content: `
<h2>Problema devizelor "din șablon"</h2>
<p>Majoritatea firmelor mici și medii pleacă de la un Excel cu lista lor de articole-standard. Devine inutilizabil rapid pentru că:</p>
<ul>
  <li>Prețurile materialelor se schimbă lunar — Excel-ul nu știe</li>
  <li>Articole noi (sau combinații) trebuie introduse manual de fiecare dată</li>
  <li>Manopera variază între echipe și e estimată "din burtă"</li>
  <li>Erorile de copy-paste duc la oferte cu marje fals negative</li>
</ul>

<h2>Cum schimbă AI-ul jocul</h2>
<p>Un AI antrenat pe devizele tale anterioare poate să:</p>
<ul>
  <li>Sugereze articolele potrivite dintr-o descriere în limbaj natural ("zugrăveli 50 mp în 2 straturi cu vopsea lavabilă")</li>
  <li>Estimeze cantitățile pe baza unor referințe (lungime, suprafață, volum)</li>
  <li>Propună prețurile manoperă și material bazate pe istoricul firmei tale, nu pe medii naționale</li>
  <li>Învețe din corectările tale — cu fiecare deviz, recomandările devin mai precise</li>
</ul>

<h2>Ce trebuie să accepți: AI-ul nu e infailibil</h2>
<p>Tratează AI-ul ca pe un ofertant junior, nu ca pe un expert. Verifică întotdeauna:</p>
<ul>
  <li>Articolele propuse sunt cele potrivite (uneori sugerează articole similare dar nu identice)</li>
  <li>Cantitățile sunt calculate corect pentru suprafața/volumul real</li>
  <li>Prețurile reflectă piața actuală (mai ales pentru materiale volatile: oțel, lemn, polistiren)</li>
</ul>

<h2>Ce câștigi la final</h2>
<p>O firmă care emite 15–20 de devize pe lună economisește <strong>~45 ore</strong> de muncă cu AI vs. Excel manual. Plus că răspunzi cererilor de ofertă în aceeași zi, ceea ce crește rata de conversie cu 20–30%.</p>
    `.trim(),
  },
  {
    slug: "e-factura-anaf-firme-constructii",
    title: "e-Factura ANAF: tot ce trebuie să știe firmele de construcții",
    excerpt:
      "De la 1 ianuarie 2024, e-Factura prin RO e-Factura ANAF e obligatorie în relația B2B. Iată ce trebuie să faci dacă firma ta de construcții nu e încă conformă.",
    date: "2026-03-15",
    readingTime: "5 min",
    category: "Legal",
    image: "/etesa-logo.png",
    keywords: "e-factura ANAF, factura electronica constructii, RO e-Factura, factura B2B Romania",
    content: `
<h2>Ce este RO e-Factura</h2>
<p>RO e-Factura e platforma oficială ANAF prin care toate facturile B2B (între firme) emise de companii din România trebuie raportate într-un format XML standardizat (UBL 2.1) în maxim 5 zile lucrătoare de la emitere.</p>

<h2>Pentru cine e obligatoriu?</h2>
<ul>
  <li><strong>De la 01.07.2024:</strong> toate firmele înregistrate în România, în relațiile B2B</li>
  <li><strong>De la 01.01.2025:</strong> și pentru B2C (relațiile cu persoane fizice)</li>
  <li>Excepții: facturi de utilități, facturi în valori mici (sub plafonul fiscal)</li>
</ul>

<h2>Ce se întâmplă dacă nu raportezi</h2>
<p>Amenzile pleacă de la <strong>5.000 RON</strong> pentru întârzieri și pot ajunge la <strong>10.000 RON</strong> pentru neraportare. Pentru o firmă cu volum mare de facturi, costurile cumulate pot fi semnificative.</p>

<h2>Cum să te conformezi rapid</h2>
<p>Sunt 3 căi:</p>
<ol>
  <li><strong>Manual prin portalul ANAF</strong> — gratuit, dar consumă timp (~5 min/factură) și e ușor să greșești formatul XML</li>
  <li><strong>Contabilitate externalizată</strong> — costă, dar contabilul preia raportarea</li>
  <li><strong>Software integrat</strong> — emiterea facturii și raportarea se fac într-un singur click</li>
</ol>

<h2>Particularități pentru construcții</h2>
<p>Firmele de construcții au câteva nuanțe specifice:</p>
<ul>
  <li><strong>Taxare inversă</strong> pentru lucrări către alte firme constructori — codul fiscal trebuie marcat corect în XML</li>
  <li><strong>Devize ca anexă</strong> — XML-ul UBL 2.1 permite atașarea devizului ca PDF</li>
  <li><strong>Stadii fizice</strong> — facturarea parțială (situații de lucrări) necesită numerotare specifică</li>
</ul>

<p>Platforma e-Tesa gestionează automat toate aceste aspecte: emiți factura, iar raportarea către e-Factura ANAF se face în background, cu acuratețe 100%.</p>
    `.trim(),
  },
  {
    slug: "foi-parcurs-digitale-economie",
    title: "Foi de parcurs digitale: economisește 5 ore pe lună per vehicul",
    excerpt:
      "Foile de parcurs pe hârtie sunt cea mai birocratică sarcină din transport. Cum să le digitalizezi fără să sperii șoferii vechi din firmă.",
    date: "2026-02-28",
    readingTime: "4 min",
    category: "Vehicule",
    image: "/etesa-logo.png",
    keywords: "foi de parcurs, foaie parcurs digitala, gestiune vehicule constructii, ITP RCA alerta",
    content: `
<h2>Ce probleme rezolvă o foaie de parcurs digitală</h2>
<ul>
  <li>Citiri eronate de kilometraj transcrise în Excel</li>
  <li>Foi pierdute la sfârșit de lună — imposibil de reconstituit</li>
  <li>ITP-uri și polițe RCA expirate fără ca nimeni să observe</li>
  <li>Imposibilitatea de a verifica dacă șoferul X a folosit într-adevăr mașina Y</li>
</ul>

<h2>Funcțiile esențiale</h2>
<p>O soluție bună trebuie să aibă:</p>
<ul>
  <li><strong>Citire km la pornire/oprire</strong> — angajatul completează din aplicația mobilă</li>
  <li><strong>Validare automată</strong> — km de sfârșit nu poate fi mai mic decât km de început</li>
  <li><strong>Alerte ITP/RCA</strong> — notificare cu 14 zile înainte de expirare</li>
  <li><strong>Export Excel</strong> pentru contabilitate și control fiscal</li>
  <li><strong>Istoric per vehicul</strong> — vezi cine a condus când și unde</li>
</ul>

<h2>Cum convingi șoferii vechi să folosească aplicația</h2>
<p>Cea mai mare rezistență vine de la angajații cu vechime care nu vor să "se complice". Trei tactici care funcționează:</p>
<ol>
  <li><strong>Primele 2 săptămâni — completare dublă</strong>: și pe hârtie, și în aplicație. Așa văd că nu pierd nimic.</li>
  <li><strong>Sărbătorește micile victorii</strong>: "Săptămâna asta s-au completat 100% online — bravo!"</li>
  <li><strong>Arată-le bonusul</strong>: aplicația arată automat kilometrajul lor, ITP-ul mașinii lor, polița. Sunt informații pe care înainte trebuiau să le ceară.</li>
</ol>

<h2>ROI rapid</h2>
<p>O flotă de 5 vehicule cu foi de parcurs digitale economisește <strong>25 ore lunar</strong> de muncă administrativă, plus că evită amenzi pentru ITP/RCA expirate (cost mediu 2.500 RON/incident).</p>
    `.trim(),
  },
  {
    slug: "gestiune-proiect-constructii-deviz-receptie",
    title: "Cum să gestionezi un proiect de construcții de la deviz la recepție",
    excerpt:
      "Un proiect de construcții bine condus respectă termenul, încadrarea bugetară și calitatea. Iată cei 7 pași esențiali pe care îi sărim de obicei.",
    date: "2026-01-18",
    readingTime: "10 min",
    category: "Proiecte",
    image: "/etesa-logo.png",
    keywords: "gestiune proiect constructii, management santier, proces verbal receptie, contract antrepriza",
    content: `
<h2>Pasul 1: Devizul ofertant ≠ devizul de execuție</h2>
<p>Greșeala #1 a firmelor mici e să trateze devizul-ofertant (cel trimis beneficiarului) ca pe devizul-de-execuție (cel pe baza căruia conduci proiectul). Diferențele:</p>
<ul>
  <li>Devizul-ofertant are marje și surplus — beneficiarul vede prețul final</li>
  <li>Devizul-de-execuție are costurile reale — pe el îl folosești ca să controlezi profitabilitatea</li>
</ul>

<h2>Pasul 2: Contractul cu clauze măsurabile</h2>
<p>Un contract bun definește:</p>
<ul>
  <li><strong>Termenul de execuție</strong> — cu repere intermediare (faza 1, faza 2)</li>
  <li><strong>Modalitatea de plată</strong> — avans, plăți parțiale pe faze, rest la recepție</li>
  <li><strong>Penalități</strong> — pentru întârzieri ale ambelor părți</li>
  <li><strong>Modificări de cantități</strong> — cum se aprobă suplimentările (anexe la contract)</li>
</ul>

<h2>Pasul 3: Predarea-primirea șantierului</h2>
<p>Înainte să pui prima cărămidă, semnezi un <strong>Proces Verbal de Predare-Primire</strong> cu beneficiarul. Documentează:</p>
<ul>
  <li>Starea inițială a terenului (cu fotografii)</li>
  <li>Utilitățile disponibile (apă, curent, acces)</li>
  <li>Eventuale construcții vecine de protejat</li>
</ul>

<h2>Pasul 4: Faze de execuție, nu un singur tronson</h2>
<p>Împarte proiectul în 3–6 faze cu termene clare. Pentru o casă: fundație → structură → învelitoare → instalații → finisaje exterioare → finisaje interioare. Fiecare fază se închide cu un <strong>Proces Verbal de Recepție Parțială</strong>.</p>

<h2>Pasul 5: Anexe pentru orice modificare</h2>
<p>Beneficiarul își schimbă tot timpul ideea. Nu accepta modificări verbale — orice cantitate suplimentară sau lucrare nouă se documentează printr-o <strong>Anexă la contract</strong> care:</p>
<ul>
  <li>Identifică modificarea (Anexa 1 la Contract X, data Y)</li>
  <li>Definește lucrările suplimentare (cantitate, preț unitar, preț total)</li>
  <li>Stabilește impactul pe termen (dacă proiectul se prelungește)</li>
  <li>E semnată de ambele părți înainte de începerea lucrării</li>
</ul>

<h2>Pasul 6: Controlul costurilor în timp real</h2>
<p>La fiecare sfârșit de săptămână, compari:</p>
<ul>
  <li>Costurile reale (manoperă pontată + materiale facturate) vs devizul-de-execuție</li>
  <li>Procentul de avansare fizică vs procentul de avansare financiară</li>
</ul>
<p>Dacă financiarul depășește fizicul, ai o problemă — investighează imediat.</p>

<h2>Pasul 7: Recepția finală</h2>
<p>La final, semnezi <strong>Procesul Verbal de Recepție Finală</strong>, care include:</p>
<ul>
  <li>Confirmarea că toate lucrările din contract + anexe au fost executate</li>
  <li>Eventuale remedieri minore (cu termen)</li>
  <li>Începerea perioadei de garanție</li>
  <li>Eliberarea garanției de bună execuție (sau partea aferentă)</li>
</ul>

<p>Toate aceste documente — devize, contract, anexe, procese verbale — pot fi generate și legate între ele într-o platformă unică precum e-Tesa. Atât pentru istoricul firmei, cât și pentru orice control fiscal sau juridic ulterior.</p>
    `.trim(),
  },
];

export const getArticleBySlug = (slug) => blogArticles.find((a) => a.slug === slug) || null;

export const formatArticleDate = (iso) => {
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("ro-RO", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
};
